import { EnvironmentProviders } from '@angular/core';

import {
  ArticleExportPermissions,
  createExportManagementSettingsPlugin,
} from '@mp/export-management/export-history/feature';
import { provideModuleInfo } from '@mp/shared/util';
import { provideModuleOrganizationSettings, provideModulePermissions } from '@mpk/shared/data-access';

const moduleName = 'ExportManagement';

export function provideExportFeature(): EnvironmentProviders[] {
  return [
    provideModuleInfo(moduleName, {
      displayName: 'Export',
    }),
    provideModulePermissions(moduleName, ArticleExportPermissions),
    provideModuleOrganizationSettings(moduleName, createExportManagementSettingsPlugin),
  ];
}
